namespace $ {
	export class $shm_hitalama_skills_catalog extends $giper_baza_entity.with({
		Entries: $giper_baza_list_link.to( ()=> $shm_hitalama_skills_entry ),
		Orders: $giper_baza_dict_to( $giper_baza_atom_list ),
		Github_repository: $giper_baza_atom_text,
	}) {
		@ $mol_mem
		static current() {
			const domain = this.$.$shm_hitalama_domain.instance()
			this.$.$shm_hitalama_map_component_ready.read( domain )
			return domain.Skills_catalog()?.remote() ?? null
		}
		@ $mol_action
		static ensure() {
			const previous = this.current()
			if( previous ) return previous
			const domain = this.$.$shm_hitalama_domain.instance()
			if( !domain.can_change() ) throw new Error( 'Каталог скиллов не настроен. Обратитесь к администратору домена.' )
			const catalog = $mol_wire_sync( this ).allocate( domain.link().str )
			domain.Skills_catalog( null )!.remote( catalog )
			return catalog
		}
		static allocate( domain: string ) {
			return this.$.$giper_baza_glob.land_grab( [[ null, this.$.$giper_baza_rank_make( 'post', 'just' ) ]] ).Data( this )
		}
		entries() {
			this.$.$shm_hitalama_map_component_ready.read( this )
			const entries = this.Entries()?.remote_list() ?? []
			for( const entry of entries ) this.$.$shm_hitalama_map_component_ready.read( entry )
			return entries
		}
		entry( id: string ) { return this.entries().find( entry => entry.link().str === id ) ?? null }
		tree() {
			const entries = this.entries()
			return new this.$.$shm_hitalama_skills_tree(
				entries.map( entry => ({ id: entry.link().str, parent: entry.Parent()?.val() ?? '', group: entry.group() }) ),
				new Map( [ '', ...entries.filter( item => item.group() ).map( item => item.link().str ) ].map( id => [ id, this.Orders()?.key( id || 'root' )?.val()?.filter( ( value ): value is string => typeof value === 'string' ) ?? [] ] ) ),
			)
		}
		private drafts = new WeakMap<object, $shm_hitalama_skills_entry>()
		draft( operation: object ) {
			if( !this.can_change() ) throw new Error( 'Нет прав на изменение каталога скиллов.' )
			let draft = this.drafts.get( operation )
			if( !draft ) { draft = this.land().area_make().Data( $shm_hitalama_skills_entry ); this.drafts.set( operation, draft ) }
			return draft
		}
		@ $mol_action
		create( operation: object, kind: string, name: string, parent = '' ) {
			name = name.trim()
			if( kind !== 'group' && kind !== 'skill' ) throw new Error( 'Неизвестный тип элемента.' )
			if( !name ) throw new Error( 'Укажите название.' )
			if( kind === 'skill' && !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test( name ) || kind === 'skill' && name.length > 64 ) throw new Error( 'Имя скилла: до 64 латинских строчных букв, цифр и дефисов.' )
			if( parent && !this.entry( parent )?.group() ) throw new Error( 'Группа не найдена.' )
			const previous = this.drafts.get( operation )
			if( kind === 'skill' && this.entries().some( item => item.name() === name && item.link().str !== previous?.link().str ) ) throw new Error( 'Скилл с таким именем уже существует.' )
			const draft = $mol_wire_sync( this ).draft( operation )
			if( kind === 'skill' && this.entries().some( item => item.name() === name && item.link().str !== draft.link().str ) ) throw new Error( 'Скилл с таким именем уже существует.' )
			if( this.Entries()?.has( draft.link() ) ) return draft
			draft.Kind( null )!.val( kind )
			draft.Parent( null )!.val( parent )
			draft.Name( null )!.val( kind === 'skill' ? name : '' )
			draft.title( name )
			if( kind === 'skill' ) draft.document( `---\nname: ${ name }\ndescription: ""\n---\n\n` )
			const list = this.Entries( null )!
			if( !list.has( draft.link() ) ) list.remote_add( draft )
			return draft
		}
		@ $mol_action
		node_move( id: string, parent: string, siblings: readonly string[] ) {
			this.$.$shm_hitalama_map_component_ready.read( this )
			if( !this.can_change() ) throw new Error( 'Нет прав на изменение каталога скиллов.' )
			const entry = this.entry( id )
			if( !entry ) throw new Error( 'Элемент не найден.' )
			if( parent && !this.entry( parent )?.group() ) throw new Error( 'Группа не найдена.' )
			const tree = this.tree()
			for( let cursor = parent; cursor; cursor = tree.parents.get( cursor ) ?? '' ) if( cursor === id ) throw new Error( 'Нельзя переместить группу внутрь себя.' )
			const expected = [ ...( parent ? tree.children( parent ) : tree.roots ).filter( child => child !== id ), id ]
			if( siblings.length !== expected.length || new Set( siblings ).size !== expected.length || expected.some( child => !siblings.includes( child ) ) ) throw new Error( 'Список скиллов изменился. Повторите перенос.' )
			entry.Parent( null )!.val( parent )
			this.Orders( null )!.key( parent || 'root', null )!.val( [ ...siblings ] )
		}
		@ $mol_action
		remove( id: string ) {
			this.$.$shm_hitalama_map_component_ready.read( this )
			if( !this.can_change() ) throw new Error( 'Нет прав на изменение каталога скиллов.' )
			const plan = $mol_wire_sync( this ).removal( id )
			if( !plan ) return
			for( const atom of plan.parents ) atom.val( plan.parent )
			plan.order.val( plan.siblings )
			plan.list.cut( plan.link )
		}
		removal( id: string ) {
			const entry = this.entry( id )
			if( !entry ) return null
			const tree = this.tree(), parent = tree.parents.get( id ) ?? ''
			const siblings = ( parent ? tree.children( parent ) : tree.roots ).flatMap( child => child === id ? tree.children( id ) : [ child ] )
			const parents = this.entries().filter( item => tree.parents.get( item.link().str ) === id ).map( item => item.Parent( null )! )
			const order = this.Orders( null )!.key( parent || 'root', null )!, list = this.Entries()!
			for( const atom of parents ) atom.val()
			order.val(); list.items_vary()
			return { parent, siblings, parents, order, list, link: entry.link() }
		}
	}
}
